export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_07.abdc39e0.jpg";